import React, { useCallback, useEffect, useState } from "react";
import "./CreateProfilePage.css";
import { Form, Input, Button, Col, Select, Row, Upload } from "antd";
import authHeader from "../Authentication/authHeader";
import axios from "axios";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import config from "../../config";
import { UploadOutlined } from "@ant-design/icons";

export default function CreateProfilePage() {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { Option } = Select;
  const [userList, setUserList] = useState([]);
  const history = useHistory();
  const [imageFile, setImageFile] = useState([]);

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/employee/users/`, { headers: authHeader() })
      .then((results) => {
        setUserList(results?.data);
      });
  }, []);

  const handleFileChange = useCallback(async ({ fileList }) => {
    if (fileList.length > 1) {
      Swal.fire({
        title: "Error",
        text: "Can't upload more than 1 file",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }
    setImageFile(fileList);

    if (fileList && fileList[0]) {
      const file = fileList[0].originFileObj;

      try {
        const formData = new FormData();
        formData.append("file_name", file.name);
        formData.append("mime_type", file.type);
        formData.append("file_type", "image");
        formData.append("file_uid", file.uid);

        const response = await axios.post(
          `${config.baseUrl}/api/upload-file/`,
          formData,
          {
            headers: authHeader(),
          }
        );

        const { signedUrl } = response.data;

        const s3Response = await axios.put(signedUrl, file, {
          headers: {
            "Content-Type": file.type,
          },
        });

        if (s3Response.status === 200) {
          Swal.fire({
            title: "Success",
            text: "Image Uploaded Successful",
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          throw new Error("Failed to upload the image to S3");
        }
      } catch (error) {
        const errorMessage = error?.response?.data?.message || "Upload failed";
        setImageFile([]);
        Swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  }, []);
  
  const handleSubmit = (data) => {
    if (imageFile[0]?.originFileObj) {
      const file = imageFile[0].originFileObj;
      
      data.signature = file?.uid+"_"+file?.name;
      console.log("from submit",data.signature)
    }
    fetch(`${config.baseUrl}/employee/create_profile/`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-type": "application/json",
        ...authHeader(),
      },
    })
      .then((data) => {
        if (data?.status === 201) {
          Swal.fire({
            title: "Employee Profile",
            text: "Created Successfully",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            history.push("/employee");
          });
        } else {
          Swal.fire({
            title: "Error",
            text: data?.statusText,
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Unsuccessfully",
          text: err.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      });
  };
  return (
    <div className="createProfilePage">
      <div className="createProfileHeaderSection">
        <h5 style={{ color: "#46604A" }}>CREATE EMPLOYEE PROFILE</h5>
      </div>

      <div className="createProfileContainer">
        <div className="createProfilePageSection">
          <header className="text-center mt-4">
            <strong>Employee Profile Create Form</strong>
          </header>
          <Form
            className="mt-5"
            form={form}
            onFinish={handleSubmit}
            layout="vertical"
          >
            <Row gutter={[16, 16]}>
              {/* User */}
              <Col xs={24} sm={12} md={8} lg={12}>
                <Form.Item
                  hasFeedback
                  label="User"
                  name="user"
                  rules={[
                    { required: true, message: "Please select employee" },
                  ]}
                >
                  <Select placeholder="User">
                    {userList?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.first_name + " " + item.last_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              {/* ID */}
              <Col xs={24} sm={12} md={8} lg={12}>
                <Form.Item
                  hasFeedback
                  label="Employee ID"
                  name="employee_id"
                  rules={[
                    { required: true, message: "Please enter Employee ID" },
                  ]}
                >
                  <Input placeholder="Employee ID" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 16]}>
              {/* Job Title */}
              <Col xs={24} sm={12} md={8} lg={12}>
                <Form.Item
                  label="Job Title"
                  name="job_title"
                  hasFeedback
                  initialValue=""
                  rules={[
                    {
                      required: true,
                      message: "Please enter job title",
                    },
                  ]}
                >
                  <Input placeholder="Enter job title" />
                </Form.Item>
              </Col>
              {/* Designation */}
              <Col xs={24} sm={12} md={8} lg={12}>
                <Form.Item
                  label="Designation"
                  name="designation"
                  hasFeedback
                  initialValue=""
                  rules={[
                    {
                      required: true,
                      message: "Please enter designation",
                    },
                  ]}
                >
                  <Input placeholder="Enter designation" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              {/* Phone Number */}
              <Col xs={24} sm={12} md={8} lg={12}>
                <Form.Item
                  hasFeedback
                  label="Phone Number"
                  name="phoneNumber"
                  rules={[
                    {
                      required: true,
                      message: "Please enter employee's phone number",
                    },
                    {
                      pattern: /^(?:\+?88)?01[3-9]\d{8}$/,
                      message: "Please enter a valid phone number",
                    },
                  ]}
                >
                  <Input placeholder="Phone Number" type="tel" />
                </Form.Item>
              </Col>

              {/* National ID */}
              <Col xs={24} sm={12} md={8} lg={12}>
                <Form.Item
                  hasFeedback
                  label="National ID"
                  name="nationalID"
                  initialValue={0}
                >
                  <Input placeholder="National ID" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              {/* signature */}
              <Col xs={24} sm={12} md={8} lg={12}>
                <Form.Item
                  label="Signature"
                  name="signature"
                  hasFeedback
                  rules={[
                    { required: true, message: "Please upload your signature" },
                  ]}
                >
                  <Upload
                    onChange={handleFileChange}
                    fileList={imageFile}
                    beforeUpload={() => false}
                    listType="picture-card"
                  >
                    <button
                      style={{ border: 0, background: "none" }}
                      type="button"
                    >
                      <UploadOutlined />
                      <div style={{ marginTop: 1 }}>Signature</div>
                    </button>
                  </Upload>
                </Form.Item>
              </Col>
              {/* Address Details */}
              <Col xs={24} sm={12} md={8} lg={12}>
                <Form.Item
                  label="Address Details"
                  name="address_details"
                  hasFeedback
                  initialValue=""
                >
                  <TextArea placeholder="Enter address details" />
                </Form.Item>
              </Col>
            </Row>

            {/* Submit Button */}
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item>
                <Button
                  style={{ backgroundColor: "#46604A", color: "white" }}
                  htmlType="submit"
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Form>
        </div>
      </div>
    </div>
  );
}
